import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/getdirectlyunderbindpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/getdirectlyunderbindall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getRootVehicleInfoGroups = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/getrootvehicleinfogroups' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getChildrenGroups = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/getchildrenvehicleinfogroups/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientBindVehicleInfoGroupsPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/getclientbindvehicleinfogroupspage/' + params.userId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindVehicleInfoGroupsToUser = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/bindvehicleinfogroupstouser/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindUserVehicleInfoGroups = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/unbinduservehicleinfogroups/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const bindForwardlyNoticeUsers = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/bindforwardlynoticeusers/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindForwardlyNoticeUsers = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/unbindforwardlynoticeusers/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchAddBusinessNotes = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/batchaddbusinessnotes/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const myBatchAddBusinessNotes = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfogroup/mybatchaddbusinessnotes/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}
